import { FC, useEffect, useState } from 'react';
import { DotLottie, DotLottieReact } from '@lottiefiles/dotlottie-react';
import { Asset, Box } from '@altermaind/web/ui';

type Props = {
  speaking?: boolean;
};

export const AvatarAltermaind: FC<Props> = ({ speaking = false }) => {
  const [dotLottie, setDotLottie] = useState<DotLottie | null>(null);

  useEffect(() => {
    if (dotLottie) {
      if (speaking) {
        dotLottie.play();
      } else {
        dotLottie.pause();
      }
    }
  }, [speaking, dotLottie]);

  return (
    <>
      <Box
        position='absolute'
        top='50%'
        left='50%'
        height='120px'
        width='120px'
        borderRadius='50%'
        backgroundColor='black'
        style={{
          transform: 'translate(-50%, -50%)',
        }}
      />
      <Box
        left='0'
        right='0'
        top='50%'
        position='absolute'
        style={{
          transform: 'translateY(-50%)',
        }}
      >
        <Asset width='50' domain='images' name='logoAltermaind' />
      </Box>
      <Box
        style={{
          opacity: speaking ? 1 : 0.6,
          transition: 'opacity 0.3s ease-in-out',
        }}
        width='90%'
      >
        <DotLottieReact
          dotLottieRefCallback={setDotLottie}
          loop
          src='https://lottie.host/c26186dd-c3ee-4082-bf75-a642e697ef72/f3zfG8Q8gO.lottie'
        />
      </Box>
    </>
  );
};
